var magicStyles = [" [data-v-352fe844-host],:host{max-width:100%}.message[data-v-352fe844]{font-size:.81rem;font-weight:var(--magic-font-weight-semibold,600);margin:0 0 var(--magic-space,16px);color:var(--magic-text-error,#dd2727)}"];

export default magicStyles;
